import React from 'react'
import { required, SelectInputProps } from 'react-admin'
import { DepSelectInput } from '../../inputs/DepSelectInput'
import { TEMPORARYREQUEST_FIELDS } from '../../../providers/localization/constant'
import { useFormContext } from 'react-hook-form'

const defaultProps = {
  label: `${TEMPORARYREQUEST_FIELDS}.cancel_reason.label`,
  source: 'action_type',
  choices: [
    { id: 'sold_out', name: `${TEMPORARYREQUEST_FIELDS}.cancel_reason.choices.sold_out` },
    { id: 'inconvenience', name: `${TEMPORARYREQUEST_FIELDS}.cancel_reason.choices.inconvenience` },
    { id: 'other', name: `${TEMPORARYREQUEST_FIELDS}.cancel_reason.choices.other` },
  ],
}

export const CancelSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  disabled = false,
  ...props
}) => {
  const { setValue } = useFormContext()

  const targetLinkOnChange = (e): void => {
    const value = e.target.value
    setValue('action_type', value)
  }
  return (
    <DepSelectInput
      depField='status'
      expectedValue='cancel'
      margin='none'
      disabled={disabled}
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      translateChoice={true}
      onChange={targetLinkOnChange}
      {...props}
    />
  )
}

CancelSelectInput.defaultProps = defaultProps
